import React from "react";
import { shallow } from "zustand/shallow";
import styled from "styled-components";
import { Button, Text, Flex } from "@mantine/core";

import ViewTitle from "@components/Microsite/ViewTitle";
import { LoyaltyMembership } from "@components/LoyaltyMembership";
import { HogMembership } from "@components/LoyaltyMembership";

import hogLogo from "@assets/images/hog-logo-color.png";

import useAppStore from "@components/Microsite/microsite-store";

export default function MembershipView() {
  const {
    location,
    setActiveStep,
    setMembershipInfo,
    user,
    coords,
    entityInfo,
    setUser,
    searchParamsOnInit,
  } = useAppStore(
    (state) => ({
      coords: state.coords,
      location: state.location,
      setActiveStep: state.setActiveStep,
      setMembershipInfo: state.setMembershipInfo,
      user: state.user,
      entityInfo: state.entityInfo,
      setUser: state.setUser,
      searchParamsOnInit: state.searchParamsOnInit,
    }),
    shallow
  );

  const isVehicleDataEffort = entityInfo.is_vehicle_data_effort;

  return (
    <div>
      <StyledLogo src={hogLogo} />
      {isVehicleDataEffort && (
        <Text c="white" align="center" size="lg" mb="xl">
          A Member ID is required to receive mileage credit. Ask a dealer if you
          need help locating your ID number.
        </Text>
      )}
      <HogMembership
        additionalReqData={{
          ...coords,
          location_id: entityInfo.organization_id ? null : location?.id,
          organization_id: entityInfo.organization_id,
          user_id: user?.id,
          campaign_effort_id: entityInfo.campaign_effort_id,
        }}
        setMembershipInfo={(e) => {
          setMembershipInfo(e);
          setUser({
            ...user,
            hog_membership_data: {
              ...e,
            },
          });
          // setActiveStep("vehicle");
          if (location && !location.present_at_location) {
            setActiveStep("present_at_location");
          } else {
            setActiveStep("vehicle");
          }
        }}
        searchParamsHogIdValue={searchParamsOnInit?.hog_id}
        userInfo={user}
      />
    </div>
  );

  return (
    <div>
      <StyledLogo src={hogLogo} />
      {/* <ViewTitle
        title=""
        subtitle={`Harley Owners Group and Passenger (formerly Associate members), add your Member ID here`}
      /> */}
      {isVehicleDataEffort && (
        <Text c="white" align="center" size="lg" mb="xl">
          A Member ID is required to receive mileage credit. Ask a dealer if you
          need help locating your ID number.
        </Text>
      )}
      {user && (
        <LoyaltyMembership
          additionalReqData={{
            check: true,
            user_id: user.id,
            user_location_id: user.user_location_id,
            variety: 1,
            campaign_effort_id: entityInfo.campaign_effort_id,
            dashboard: false,
          }}
          codeVerificationData={{
            ...coords,
            user_location_id: user?.user_location_id,
            campaign_effort_id: entityInfo.campaign_effort_id,
            location_id: location?.id,
            user_id: user?.id,
          }}
          setMembershipInfo={(e) => {
            setMembershipInfo(e);
            setActiveStep("vehicle");
          }}
          rejectUnverified
        >
          {/* {!entityInfo.require_membership && ( */}
          {!isVehicleDataEffort && (
            <Button
              onClick={() => setActiveStep("vehicle")}
              size="xs"
              c="dark"
              color="gray.1"
              radius="lg"
            >
              I'll do this later
            </Button>
          )}
        </LoyaltyMembership>
      )}
    </div>
  );
}

const StyledLogo = styled.img`
  max-width: 300px;
  margin: 0 auto 1em auto;
  display: block;
`;
